module.exports = __webpack_public_path__ + "img/sort／phone／Shooting@2x.d327c59e.png";